module.exports = __webpack_public_path__ + "img/f3-1-r.a83f57b7.png";